import styled from "styled-components";

export const Container = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
`;

export const Label = styled.label`
    font-size: 1.1rem;
`;

export const Input = styled.input`
    width: 100%;
    border: none;
    border: 1.5px solid var(--mainTheme);
    border-radius: 5px;
    padding: 0.7rem;
    ${props => props.removeMargin ? "margin-bottom: 0;" : "margin-bottom: 1.5rem;"}
`;
